import type { ContractEffectiveStatus, TransformedContract } from '@/types/billing';

/**
 * One status vocabulary for contract lists: upper case, with the stored
 * lifecycle values mapped onto the effective ones (ACTIVE is in effect,
 * ARCHIVED has expired). Unknown values pass through upper-cased.
 */
export function normalizeContractStatus(status?: string | null): ContractEffectiveStatus | string {
  const normalized = (status ?? '').toUpperCase();
  if (normalized === 'ACTIVE') return 'IN_EFFECT';
  if (normalized === 'ARCHIVED') return 'EXPIRED';
  if (normalized === 'DRAFT' || normalized === 'FUTURE') return 'UPCOMING';
  if (normalized === 'INACTIVE') return 'CANCELLED';
  return normalized;
}

/**
 * A contract that is in effect or upcoming and not already terminated can be
 * ended. The API's effective status decides; without it the stored status does.
 */
export function canEndContract(contract: Pick<TransformedContract, 'status' | 'effectiveStatus'>): boolean {
  if (normalizeContractStatus(contract.status) === 'TERMINATED') return false;
  const status = normalizeContractStatus(contract.effectiveStatus || contract.status);
  return status === 'IN_EFFECT' || status === 'UPCOMING';
}
